import type { Stripe } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';

let stripePromise: Promise<Stripe | null> | null = null;

/** Loads Stripe.js the first time a page needs it, then reuses that instance.
 * The `/pure` entry point does not inject the script on import, so pages
 * other than /payment never fetch js.stripe.com. A failed load clears the
 * cache, so the next call tries again instead of reusing the rejection. */
export function getStripe(publishableKey: string): Promise<Stripe | null> {
  if (!stripePromise) {
    stripePromise = loadStripe(publishableKey).catch((err: unknown) => {
      stripePromise = null;
      throw err;
    });
  }
  return stripePromise;
}
